import { useIntl } from "react-intl";
import * as yup from "yup";
import { PeekAddressInput } from "@piiqtechnologies/ui-components";
import messages from "../messages.i18n";
export const useManualEntryFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        communityName: yup.string().required(intl.formatMessage(messages.manualCommunityNameRequired)),
        communityAddress: yup
            .object()
            .nullable()
            .required(intl.formatMessage(messages.manualAddressRequired))
            .test("has-description", intl.formatMessage(messages.manualAddressRequired), (value) => {
            return Boolean(value && value.description);
        }),
        communityWebsite: yup
            .string()
            .url(intl.formatMessage(messages.websiteInvalid))
            .required(intl.formatMessage(messages.manualWebsiteRequired)),
    });
};
export const ManualEntryFormInitialValues = {
    communityName: "",
    communityAddress: null,
    communityWebsite: "",
};
export const useManualEntryFormFields = () => {
    const intl = useIntl();
    return [
        {
            id: "communityName",
            label: intl.formatMessage(messages.manualCommunityNameLabel),
            placeholder: intl.formatMessage(messages.manualCommunityNamePlaceholder),
            required: true,
        },
        {
            id: "communityAddress",
            label: intl.formatMessage(messages.manualAddressLabel),
            placeholder: intl.formatMessage(messages.manualAddressPlaceholder),
            required: true,
            component: PeekAddressInput,
        },
        {
            id: "communityWebsite",
            label: intl.formatMessage(messages.manualWebsiteLabel),
            placeholder: intl.formatMessage(messages.manualWebsitePlaceholder),
            required: true,
        },
    ];
};
